module.exports = __webpack_public_path__ + "img/rooms_booked.bc56aba9.svg";